import { createContext, use } from 'react'
import type { User } from 'firebase/auth'
import type { AccountRead, BrandListItem } from '../../client'

export type AuthState = {
  user: User | null
  account: AccountRead | null
  brand: BrandListItem | null
  selectBrand: (brandId: number) => void
  loading: boolean
  refreshAccount: () => Promise<void>
}

export const AuthContext = createContext<AuthState>({
  user: null,
  account: null,
  brand: null,
  selectBrand: () => {},
  loading: true,
  refreshAccount: async () => {},
})

export function useAuth() {
  return use(AuthContext)
}
